import React from 'react'
import tw from 'tailwind-styled-components'
import {noop} from 'ts-essentials'
import {Notification, NotificationProps} from './notification'

export const NotificationPopup = (props: NotificationProps) => {
  return (
    <div className="z-[2147483647] absolute">
      <TwOverlay onClick={props.onClose ?? noop} />
      <TwForeground>
        <Notification {...props} />
      </TwForeground>
    </div>
  )
}

const TwOverlay = tw.div`
  z-0
  bg-generic-black
  opacity-64
  fixed 
  top-0 
  bottom-0 
  left-0 
  right-0
`

const TwForeground = tw.div`
  z-1
  fixed 
  top-0 
  bottom-0 
  left-0 
  right-0
  flex
  items-center
  justify-center
`
